import React from "react";
import { TextInput, required, NumberInput, SelectInput } from "react-admin";
import { Grid } from "@mui/material";
import { BuildingsIsExternalChoices } from "utils/choices";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={6}
        xs={12}
      >
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        md={6}
        xs={12}
      >
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Адрес"
          source="address"
          validate={[required()]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={2}
      >
        <NumberInput
          label="Географска ширина"
          source="latitude"
          validate={[required()]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={2}
      >
        <NumberInput
          label="Географска дължина"
          source="longitude"
          validate={[required()]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={2}
      >
        <SelectInput
          label="Външна сграда"
          source="isExternal"
          choices={BuildingsIsExternalChoices}
          validate={[required()]}
          defaultValue={false}
        />
      </Grid>
    </Grid>
  );
};

export default SaveForm;
